module.exports = __webpack_public_path__ + "assets/img/PythonEdit.41a567ad.png";